import React from 'react';
import BoatCard from './BoatCard';

const BoatGrid = ({ boats, onBoatClick }) => {
  if (boats.length === 0) {
    return (
      <div className="no-results">
        <p>No boats found matching your criteria.</p>
        <p className="no-results-hint">Try adjusting your filters to see more results.</p>
      </div>
    );
  }

  return (
    <div className="boat-grid">
      {boats.map((boat) => (
        <BoatCard
          key={boat.id}
          boat={boat}
          onClick={() => onBoatClick(boat)}
        />
      ))}
    </div>
  );
};

export default BoatGrid;
